import { FC } from 'react';
import { react2angular } from 'react2angular';
import { AlertClearNotificationSettings as AlertClearNotificationSettingsComponent } from '@splunk/olly-imm';
import type { AlertClearNotificationSettingsProps } from '@splunk/olly-imm';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../theme/ThemeProvider';

export const AlertClearNotificationSettings: FC<AlertClearNotificationSettingsProps> = ({
    skipClearNotificationStates,
    onSkipClearNotificationStatesChange,
    disabled,
    title,
}) => {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <AlertClearNotificationSettingsComponent
                skipClearNotificationStates={skipClearNotificationStates}
                onSkipClearNotificationStatesChange={onSkipClearNotificationStatesChange}
                disabled={disabled}
                title={title}
            />
        </ThemeProvider>
    );
};

export const alertClearNotificationSettings = react2angular(AlertClearNotificationSettings, [
    'skipClearNotificationStates',
    'onSkipClearNotificationStatesChange',
    'disabled',
    'title',
]);
